/* eslint no-useless-escape: 0 */

class Validator {
    static isUrl(value) {
        return /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(value);
    }
}

export default Validator;
